import { localISODate } from "../../application/water-repository";

const parseLocalDate = (value: string) => new Date(`${value}T12:00:00`);
export const shiftISODate = (value: string, days: number) => {
  const date = parseLocalDate(value);
  date.setDate(date.getDate() + days);
  return localISODate(date);
};
export const visibleWeekday = (value: string) => new Intl.DateTimeFormat("ru-RU", { weekday: "long" }).format(parseLocalDate(value));
export const visibleDayMonth = (value: string, current: string) => {
  if (value === current) return "Сегодня";
  if (value === shiftISODate(current, -1)) return "Вчера";
  const date = parseLocalDate(value);
  return `${String(date.getDate()).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(2, "0")}`;
};
